import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MemoizedSelector, Store, select } from '@ngrx/store';
import { ResourceState, ResourceStatuses } from '@platform/shared/resource.state';
import { RootState } from '@root/app.state';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-widget-selector-spinner',
  templateUrl: './widget-selector-spinner.component.html',
  styleUrls: ['./widget-selector-spinner.component.scss'],
  standalone: false,
})
export class WidgetSelectorSpinnerComponent implements OnInit {
  @Input() loadingHintTranslationKey!: string;
  @Input() selectorToWaitFor!: MemoizedSelector<object, ResourceState<any>>;
  @Input() ignoreWasPending = false;

  public isPending$ = new BehaviorSubject(false);

  public succeeded = false;
  public error?: string;
  private wasPending = false;
  private destroyRef = inject(DestroyRef);

  constructor(private store$: Store<RootState>) {}

  get hasError() {
    return Boolean(this.error);
  }

  ngOnInit(): void {
    this.isPending$.next(true);
    this.store$
      .pipe(select(this.selectorToWaitFor))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((x) => {
        if (x.status === ResourceStatuses.PENDING) {
          this.isPending$.next(true);
          this.wasPending = true;
        } else if (x.status === ResourceStatuses.SUCCEEDED && (this.wasPending || this.ignoreWasPending)) {
          this.isPending$.next(false);
          this.succeeded = true;
        } else if (x.status === ResourceStatuses.FAILED && (this.wasPending || this.ignoreWasPending)) {
          this.isPending$.next(false);
          this.succeeded = false;
          this.error = `Failed to load widget data ${x.error?.status}`;
        }
      });
  }
}
